/**
 * FloraCare — Tracking de eventos custom
 * Propósito: Listener para clicks en WhatsApp y teléfono
 * Eventos: whatsapp_click, phone_click
 * Ubicación: Cargado desde layout/theme.liquid
 * Fecha de creación: 2026-05-04
 */

(function() {
  'use strict';

  window.dataLayer = window.dataLayer || [];

  document.addEventListener('DOMContentLoaded', function() {

    /* ========================================
     * WhatsApp Click Tracking
     * Detecta links a wa.me, api.whatsapp.com y whatsapp://
     * ======================================== */
    var whatsappSelectors = [
      'a[href*="wa.me"]',
      'a[href*="whatsapp.com"]',
      'a[href*="whatsapp://"]',
      'a[href*="api.whatsapp.com"]'
    ].join(', ');

    document.querySelectorAll(whatsappSelectors).forEach(function(link) {
      link.addEventListener('click', function(e) {
        window.dataLayer.push({
          'event': 'whatsapp_click',
          'event_category': 'contact',
          'event_label': link.href,
          'link_url': link.href,
          'page_location': window.location.href
        });
      });
    });

    /* ========================================
     * Phone Click Tracking
     * Detecta links tel:
     * ======================================== */
    document.querySelectorAll('a[href^="tel:"]').forEach(function(link) {
      link.addEventListener('click', function(e) {
        var phoneNumber = link.href.replace('tel:', '');
        window.dataLayer.push({
          'event': 'phone_click',
          'event_category': 'contact',
          'event_label': phoneNumber,
          'phone_number': phoneNumber,
          'page_location': window.location.href
        });
      });
    });

  });

  /* ========================================
   * Mutation Observer para links dinámicos
   * Captura WhatsApp/phone links añadidos después del DOM load
   * (ej: popups, drawers, contenido AJAX)
   * ======================================== */
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType !== 1) return;

        /* WhatsApp links dinámicos */
        var waLinks = node.querySelectorAll
          ? node.querySelectorAll('a[href*="wa.me"], a[href*="whatsapp.com"], a[href*="api.whatsapp.com"]')
          : [];
        waLinks.forEach(function(link) {
          if (!link._floracareTracked) {
            link._floracareTracked = true;
            link.addEventListener('click', function() {
              window.dataLayer.push({
                'event': 'whatsapp_click',
                'event_category': 'contact',
                'event_label': link.href,
                'link_url': link.href,
                'page_location': window.location.href
              });
            });
          }
        });

        /* Phone links dinámicos */
        var telLinks = node.querySelectorAll
          ? node.querySelectorAll('a[href^="tel:"]')
          : [];
        telLinks.forEach(function(link) {
          if (!link._floracareTracked) {
            link._floracareTracked = true;
            link.addEventListener('click', function() {
              window.dataLayer.push({
                'event': 'phone_click',
                'event_category': 'contact',
                'event_label': link.href.replace('tel:', ''),
                'phone_number': link.href.replace('tel:', ''),
                'page_location': window.location.href
              });
            });
          }
        });
      });
    });
  });

  observer.observe(document.body || document.documentElement, {
    childList: true,
    subtree: true
  });

})();
